export default "__VITE_ASSET__BRaqy9k___"